import { redirect, RouteObject } from 'react-router';
import { PERMISSIONS } from '@/shared/constants/permissions';
import PremiumGuard from '../gate/PremiumGuard';

export const financeRoutes: RouteObject[] = [
	{
		path: 'finance',
		element: (
			<PremiumGuard
				permission={PERMISSIONS.CONCILIATION_READ}
				buyPermission={PERMISSIONS.CONCILIATION_BUY}
			/>
		),
		children: [
			{
				lazy: async () => {
					const { default: Component } = await import(
						'@/features/reconciliations/pages/ReconciliationsLayout'
					);
					return { Component };
				},
				children: [
					{
						lazy: async () => {
							const { default: Component } = await import('../pages/FinancePage');
							return { Component };
						},
						children: [
							{
								index: true,
								loader: () => redirect('reconciliations'),
							},
							{
								path: 'reconciliations',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/reconciliations/pages/ReconciliationsPage'
									);
									return { Component };
								},
							},
							{
								path: 'reconciliations/:reconciliationId',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/reconciliations/pages/ReconciliationDetailsPage'
									);
									return { Component };
								},
								children: [
									{
										path: 'overview',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/reconciliations/list/pages/ReconciliationOverviewPage'
											);
											return { Component };
										},
									},
									{
										path: 'point-of-sale',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/reconciliations/list/pages/ReconciliationPOSPage'
											);
											return { Component };
										},
									},
									{
										path: 'location',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/reconciliations/list/pages/ReconciliationLocationPage'
											);
											return { Component };
										},
									},
									{
										path: 'delegation',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/reconciliations/list/pages/ReconciliationDelegationPage'
											);
											return { Component };
										},
									},
								],
							},
						],
					},
					{
						path: 'reconciliations/:reconciliationId/transaction/:transactionId',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/reconciliations/list/pages/ReconcilitationsTransactionPage'
							);
							return { Component };
						},
					},
					{
						path: 'reconciliations/:reconciliationId/settlement/:providerReference',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/reconciliations/list/pages/ReconciliationSettlementPage'
							);
							return { Component };
						},
					},
					{
						path: 'reconciliations/:reconciliationId/point-of-sale/:machineId',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/reconciliations/list/pages/ReconciliationPOSDetailPage'
							);
							return { Component };
						},
					},
					{
						path: 'reconciliations/:reconciliationId/location/:locationName',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/reconciliations/list/pages/ReconciliationLocationDetailPage'
							);
							return { Component };
						},
					},
					{
						path: 'reconciliations/:reconciliationId/delegation/:delegationName',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/reconciliations/list/pages/ReconciliationDelegationDetailPage'
							);
							return { Component };
						},
					},
				],
			},
		],
	},
];
